import { render, staticRenderFns } from "./validate-reset-password.vue?vue&type=template&id=27660daf"
import script from "./validate-reset-password.vue?vue&type=script&lang=js"
export * from "./validate-reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports